import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import Promise from 'bluebird';
import ViewModel from '@bingads-webui-campaign-legacy/adgroup-create-advanced/viewmodel/copy-adgroup-settings';
import template from '@bingads-webui-campaign-legacy/adgroup-create-advanced/template/copy-adgroup-settings.pug';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import { getODataErrors } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import * as criterionLoader from '@bingads-webui-campaign-legacy/base-targets/util/criterionLoader';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import AdgroupSelectorProxy from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/adgroup-selector-proxy';
import AudienceAssociationModel from '@bingads-webui-campaign-legacy/audience-association/model/audienceAssociation';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize(blockedElement = null) {
    this.viewModel = new ViewModel();
    this.blockedElement = blockedElement;

    this.adgroupSelectorProxy = new AdgroupSelectorProxy({
      onAdGroupSelect: (selectedItem) => {
        this.onAdGroupSelect(selectedItem);
      },
    });
    this.adgroupSelector = this.adgroupSelectorProxy.getAdgroupSelectorView();
  }

  onAdGroupSelect(selectedItem) {
    if (_.has(selectedItem, 'Id')) {
      this.loadAdGroupAndTargets(selectedItem.Id, selectedItem.campaignId);
    } else {
      // eslint-disable-next-line no-console
      console.warn('empty selectedItem');
    }
  }

  render() {
    this.$el.empty().append(template({ i18n }));
    this.$('.copy-settings').empty().append(this.adgroupSelector.render().$el);
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  loadAdGroupAndTargets(id, campaignId) {
    let model = new AudienceAssociationModel();

    return Promise.join(
      jsdata.AdGroup.find(id, { entitySet: edmCampaign.currentAccount.Campaigns.$withKey(Number(campaignId)).AdGroups, bypassCache: true }),
      criterionLoader.load(campaignId, id, [
        'LocationCriterion',
        'RadiusCriterion',
        'LocationIntentCriterion',
        'AgeCriterion',
        'GenderCriterion',
        'JobFunctionCriterion',
        'IndustryCriterion',
        'CompanyNameCriterion',
      ]),
      (id && campaignId) && model.fetch({
        campaignId,
        adgroupId: id,
        isExpandCampaign: false,
        isExpandAdGroup: true,
      })
    ).then((result) => {
      this.trigger('copy.adgroup', result);
    }).catch(({ errors }) => {
      this.trigger('copy.errors', getODataErrors(errors));
    }).finally(withUiBlock(this.blockedElement || this.$el.parent()));
  }

  hide() {
    this.viewModel.hide(true);
  }
}
